export enum VehicleType {
  None = '',
  Walk = 'walk',
  Bike = 'bike',
  Cargobike = 'cargobike',
  Sprinter = 'sprinter',
  Caddy = 'caddy',
  LKW = 'lkw',
}
